export const TABLE_MENU_WIDTH = 280;

export const TABLE_MENU_SELECTOR =
	'[data-testid="column-handle-menu"], [data-testid="row-handle-menu"], [data-toolbar-component="menu"], [data-toolbar-nested-dropdown-menu]';

export const TABLE_ROW = 'table-row';
export const TABLE_COLUMN = 'table-column';
